import useTranslation from "@babackapp/translations/use-translation";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@babackapp/ui/components/button";
import { ChevronLeftIcon } from "lucide-react";
import { FormField } from "@babackapp/ui/components/form";
import { ControllerRenderProps, useFormContext } from "react-hook-form";
import { EditWorkflowFormValues } from "../workflow-form-fields";
import { useUpdateWorkflowActivation } from "@babackapp/private-api-client/client/use-update-workflow-activation";
import { useWorkflowContext } from "../use-workflow-context";
import SwitchToogle from "@/components-legacy/switch-toogle";

export const SetupWorkflowHeader = () => {
  const t = useTranslation();
  const { shopId } = useParams<{ shopId: string }>();
  const navigate = useNavigate();
  const { currentWorkflow } = useWorkflowContext();
  const { formState, control, getValues, watch } =
    useFormContext<EditWorkflowFormValues>();
  const { mutateAsync: updateActiveState } = useUpdateWorkflowActivation({
    shopId: shopId || "",
    workflowId: currentWorkflow.id,
  });

  const onChangeActiveState = async (
    field: ControllerRenderProps<EditWorkflowFormValues>,
    currentState: boolean,
  ) => {
    field.onChange(currentState ? "ACTIVE" : "INACTIVE");
    updateActiveState({
      body: {
        isActive: currentState,
      },
      workflowId: currentWorkflow.id,
    });
  };

  return (
    <div className="flex justify-between w-full p-4 bg-white shadow">
      <div className="flex items-center flex-1 space-x-4">
        <Button
          variant="outline"
          onClick={() => {
            navigate("/shops/" + shopId + "/workflows");
          }}
        >
          <ChevronLeftIcon className="mr-2 h-4 w-4" />

          {t("misc.back")}
        </Button>
        <h1 className="text-base font-medium text-gray-900">
          {getValues("name")}
        </h1>
      </div>

      <div className="flex space-x-4">
        <FormField
          control={control}
          name="status"
          render={({ field }) => (
            <SwitchToogle
              text={
                watch("status") === "ACTIVE"
                  ? t("misc.active")
                  : t("misc.inactive")
              }
              value={field.value === "ACTIVE"}
              onChange={(checked) => onChangeActiveState(field, checked)}
            />
          )}
        />
        <Button
          variant={"default"}
          disabled={formState.isSubmitting}
          size="lg"
          className="flex items-center"
          type="submit"
        >
          {t("workflow.saveFlow")}
        </Button>
      </div>
    </div>
  );
};
